import React from 'react';
import { useNotification } from '../../../hooks';
import { errorNotificationBuilder, NotificationTypes, successNotificationBuilder } from '../../../notifications';

export const usePaymentUpdateNotification = (operation: 'add' | 'edit') => {
  const { sendErrorNotification, sendSuccessNotification, notificationSent, setNotificationSent } = useNotification();
  const notifySuccess = (message?: string) => {
    if (!notificationSent) {
      const notificationOptions = successNotificationBuilder()
        .isVersion(NotificationTypes.FLAG)
        .withId(`${operation}-payment-method-success`)
        .withHeader('Update successful')
        .withMessage(message ? message : '')
        .build();
      sendSuccessNotification(notificationOptions);
      setNotificationSent(true);
    }
  };
  const notifyFailure = (message?: string) => {
    if (!notificationSent) {
      const notificationOptions = errorNotificationBuilder()
        .isVersion(NotificationTypes.FLAG)
        .withId(`${operation}-payment-method-failure`)
        .withHeader('Update unsuccessful')
        .withMessage(message ? message : '')
        .withDismissAfter(5000)
        .build();
      sendErrorNotification(notificationOptions);
      setNotificationSent(true);
    }
  };

  return {
    notifySuccess,
    notifyFailure,
  };
};
